import { ReportFeatures } from '@hcs/types';

export const COMP_SEARCH_QUERY_ID = 'comp-search';

export const dataHcEventSectionCompSearch = 'Comp Search';

export const COMP_SEARCH_FEATURES_SALE = [
  ReportFeatures.CompsSelectByAddress,
  ReportFeatures.CompsSelectByListing,
];

export const COMP_SEARCH_FEATURES_RENTAL = [
  ReportFeatures.RentalCompsSelectByAddress,
  ReportFeatures.RentalCompsSelectByListing,
];
